@if (show) {
  <div class="overlay">
    <mat-spinner class="spinner"></mat-spinner>
  </div>
}